// Use media time, rather than a separate timer, so pause, seeks and buffering
// cannot trigger a premature move to the next preview.
export const previewEpisodeCountdown = (duration, elapsed, rate = 1) => {
    if (!Number.isFinite(duration) || duration <= 0 || !Number.isFinite(elapsed)
        || !Number.isFinite(rate) || rate <= 0) return null;
    const remaining = (duration - Math.min(Math.max(elapsed, 0), duration)) / rate;
    const window = Math.min(8, duration / rate);
    if (!(window > 0) || !Number.isFinite(remaining) || remaining > window) return null;
    return {
        secondsRemaining: Math.ceil(remaining),
        progress: Math.min(Math.max(1 - remaining / window, 0), 1),
    };
};
